import { BackButton } from "../button/back-button";

type AccessDeniedPageProps = {
  title?: string;
  description?: string;
};

export function AccessDeniedPage({
  title = "Acesso negado",
  description = "Você não tem permissão para acessar esta página.",
}: AccessDeniedPageProps) {
  return (
    <div className="app-page">
      <BackButton />
      <h1 className="app-page-title mb-2">{title}</h1>
      <p className="app-page-subtitle">{description}</p>
    </div>
  );
}
